import { inject } from '@angular/core';
import { QuotationService } from '@retail-portal-santander-frontend/shared-data-access';
import { RedirectCommand, Router } from '@angular/router';
import { RouterEnum } from '@retail-portal-santander-frontend/shared-utils';

export const paymentGuard = () =>
  inject(QuotationService).paymentUrl() ? true : new RedirectCommand(inject(Router).parseUrl(RouterEnum.FamilyMembers));
